/**
 * Caricatore CONDIVISO di Google Maps JS (via @googlemaps/js-api-loader v2).
 *
 * Perche' un util unico:
 * - Google Maps JS puo' essere incluso UNA SOLA volta per pagina. Mescolare tag <script>
 *   manuali con il loader ufficiale genera l'errore "included multiple times".
 * - La mappa 3D del Parco (SilaWorld3D) usa `importLibrary('maps3d')`. Usiamo QUI un'unica
 *   versione condivisa ('weekly') per non entrare in conflitto tra loader: 'weekly' è il
 *   canale stabile e include sia `maps3d` (3D) sia `places` (autocomplete/recensioni).
 *   (Allineato alla configurazione verificata in produzione su silaexperiences.com.)
 *
 * Tutte le feature Places (autocomplete indirizzi #8, recensioni Google #10) passano da qui.
 */
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let _bootstrapped = false;
const _libCache = {};

export function googleMapsKey() {
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
}

export function hasGoogleMapsKey() {
  return !!googleMapsKey();
}

function ensureBootstrap() {
  if (_bootstrapped) return;
  const key = googleMapsKey();
  if (!key) throw new Error('google_maps_key_missing');
  // v:'weekly' = canale stabile, COERENTE con la mappa 3D (maps3d) e con Places.
  // Allineato alla configurazione verificata in produzione (silaexperiences.com).
  setOptions({ key, v: 'weekly' });
  _bootstrapped = true;
}

/** Carica (una sola volta, con cache) una libreria Maps: 'places', 'maps3d', 'marker', ... */
export async function loadMapsLibrary(name) {
  ensureBootstrap();
  if (!_libCache[name]) _libCache[name] = importLibrary(name).catch(error => {
    delete _libCache[name];
    throw error;
  });
  return _libCache[name];
}

export function loadPlaces() {
  return loadMapsLibrary('places');
}
